module.exports = __webpack_public_path__ + "static/media/negative.b02e348d.png";